import type { FC } from 'react';
import { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { Tabs, Tab, Box, Typography, Grid, TextField, Container } from '@material-ui/core';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import { onGet } from '../../../store/actions/global';
import Panel from '../../../components/global/Panel';
import PanelHeader from '../../../components/global/PanelHeader';
import PanelTitle from '../../../components/global/PanelTitle';
import PanelFilter from '../../../components/admin/PanelFilter';
import CurvaProduccionDesembolso from './CurvaProduccionDesembolso';
import CurvaProduccionIngreso from './CurvaProduccionIngreso';
import CurvaProduccionRemesa from './CurvaProduccionRemesa';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CurvaProduccion: FC<any> = ({ onGet: onGetExec }) => {
  const isMountedRef = useIsMountedRef();
  const title = 'Curva Producción';
  const [tabIndex, setTabIndex] = useState(0);
  const [, setYear] = useState('');
  const [, setMonth] = useState('');
  const [headers, setHeaders] = useState([]);
  const [headersRemesa, setHeadersRemesa] = useState([]);
  const [data, setData] = useState({ peso: [], pesoA: [], fcst: [], fcstA: [], real: [], realA: [], ing: [], ingA: [], fcstIngreso: [], fcstIngresoA: [], realIngreso: [], realIngresoA: [], caida: [], caidaA: [], avance: [], caidaIngreso: [], caidaIngresoA: [], avanceIngreso: [], ratioConversion: [], cantDesembolso: [], cantAccDesembolso: [], cantIngreso: [], cantAccIngreso: [] });
  const [jefatura, setJefatura] = useState('jfn-todos');
  const [fuvex, setFuvex] = useState('fuvex-todos');
  const [jefaturas, setJefaturas] = useState([{ key: 'jfn-todos', jfn: 'TODOS', meta: 0 }]);
  const [fuvexs, setFuvexs] = useState([{ key: 'fuvex-todos', fuvex: 'TODOS', meta: 0 }]);
  const refButton = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    refButton.current.click();
  }, [jefatura, fuvex]);

  const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Container sx={{ p: 0 }}>
            <Typography component="span">{children}</Typography>
          </Container>
        )}
      </div>
    );
  };

  const onChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const onSubmit = async (values) => {
    if (isMountedRef.current) {
      setYear(values?.year);
      setMonth(values?.month);
      const response = await onGetExec({
        url: '/dashboard/productionCurve',
        body: { ...values, jefatura, fuvex },
      });
      setJefaturas(response.jefaturas);
      setFuvexs(response.fuvexs);
      setHeaders(response.headers);
      setHeadersRemesa(response.headersRemesa);
      setData(response.data);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Dashboard:
          {title}
        </title>
      </Helmet>
      <Panel>
        <PanelHeader>
          <PanelTitle
            title={title}
            subTitlePrim="Dashboard"
            subTitleSec={title}
          />
        </PanelHeader>
        <PanelFilter onSubmit={onSubmit} yearMonth refButton={refButton} />
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xl={3} md={4} xs={12} style={{ display: tabIndex === 2 ? 'none' : 'inline-flex' }}>
              <TextField
                label="Jefatura:"
                name="jefatura"
                value={jefatura}
                fullWidth
                select
                size="small"
                SelectProps={{ native: true }}
                onChange={(e) => {
                  setJefatura(e.target.value);
                }}
              >
                {jefaturas.map((m) => (
                  <option key={m.key} value={m.key}>
                    {m.jfn.concat(' ').concat(`( ${m.meta}M )`)}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid item xl={3} md={4} xs={12} style={{ display: tabIndex !== 2 ? 'none' : 'inline-flex' }}>
              <TextField
                label="Fuvex:"
                name="fuvex"
                value={fuvex}
                fullWidth
                select
                size="small"
                SelectProps={{ native: true }}
                onChange={(e) => {
                  setFuvex(e.target.value);
                }}
                style={{ display: tabIndex !== 2 ? 'none' : 'inline' }}
              >
                {fuvexs.map((m) => (
                  <option key={m.key} value={m.key}>
                    {m.fuvex.concat(' ').concat(`( ${m.meta}M )`)}
                  </option>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Box>
        <Tabs value={tabIndex} onChange={onChangeTab}>
          <Tab label="Desembolsos" />
          <Tab label="Ingresos" />
          <Tab label="Remesas" />
        </Tabs>
        <TabPanel index={0} value={tabIndex}>
          <CurvaProduccionDesembolso headers={headers} data={data} />
        </TabPanel>
        <TabPanel index={1} value={tabIndex}>
          <CurvaProduccionIngreso headers={headers} data={data} />
        </TabPanel>
        <TabPanel index={2} value={tabIndex}>
          <CurvaProduccionRemesa headers={headersRemesa} data={data} />
        </TabPanel>
      </Panel>
    </>
  );
};

export default connect(null, {
  onGet,
})(CurvaProduccion);
